import { render } from "./TagList.vue?vue&type=template&id=30a9e9a9&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=30a9e9a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a9e9a9"]])

export default __exports__